<template>
    <div class="TableColumn">
      <el-table-column type="index" v-if="hidden"></el-table-column>
      <template v-for="item in displayColumns">
        <el-table-column  show-overflow-tooltip v-if="item.gridSlot && Object.keys(item.gridSlot).length > 0"
                          :align="item.align"
                          :key="item.key"
                          :prop="item.prop"
                          :label="item.label"
                          :width="item.width"
                          :fixed="item.gridFixed"
                          :formatter="(row, column, cellValue, index) => dataFormat(row, column, cellValue, index,item.type,item.format,item.mapValues,item.zeroShow)"
        >
         <!--  表头     :value="getHeaderSeletDefVal(item.default, item.type)"
          -->
          <template slot="header" slot-scope="{}" >
            <template  v-if="item.gridSlot.header && item.typeExtends === 'select'">
              <el-select v-model="item.gridSlot.headerModel"
                         @change="headerSelectChange(item.gridSlot.headerModel, item.default, item.prop, item.type)"
                         size="mini" :placeholder="$t('common.pleaseSelectLocation')"
                         class="header-select"
                         filterable>
                <el-select-options :item="item.mapValues"></el-select-options>
              </el-select>
            </template>
            <template v-else>
              <span>{{item.label}}</span>
            </template>
          </template>
          <!--  单元格        -->
          <template slot-scope="scope">
            <template v-if = "item.gridSlot.cell && item.gridSlot.cell.length > 0">
              <template v-for="objs in item.gridSlot.cell">
                <el-button v-if="objs.type === 'button'" :key="objs.id" size="mini" @click="handleClick(scope.$index, scope.row, objs.functions)">{{objs.caption}}</el-button>
                <mh-link v-else-if="objs.type === 'mhlink'" :key="objs.id" :src="scope.row[objs.srcProp]" mType="sRouter" :content="scope.row[item.prop]" :mNbr="scope.row[item.prop]" ></mh-link>
                <a v-else-if="objs.type === 'link'" :key="objs.id" :href="scope.row[item.prop]" @click.prevent="handleClick(scope.$index, scope.row, objs.functions)">{{scope.row[item.prop]}}</a>
              </template>
            </template>
            <template v-else>
              <span v-html="dataFormat(scope.row, scope.column, scope.row[item.prop], scope.$index, item.type, item.format, item.mapValues, item.zeroShow)"></span>
            </template>
<!--            <template v-for="objs in item.gridSlot.cell">-->
<!--              <el-button v-if="objs.type === 'button'" :key="objs.id" size="mini" @click="handleClick(scope.$index, scope.row, objs.functions)">{{objs.caption}}</el-button>-->
<!--              <mh-link v-else-if="objs.type === 'mhlink'" :key="objs.id" :src="scope.row[objs.srcProp]" mType="sRouter" :content="scope.row[item.prop]" :mNbr="scope.row[item.prop]" ></mh-link>-->
<!--              <a v-else-if="objs.type === 'link'" :key="objs.id" :href="scope.row[item.prop]" @click.prevent="handleClick(scope.$index, scope.row, objs.functions)">{{scope.row[item.prop]}}</a>-->
<!--            </template>-->
          </template>
        </el-table-column>
        <el-table-column  show-overflow-tooltip v-else-if="item.type === 'boolean'"
                          :align="item.align"
                          :key="item.key"
                          :prop="item.prop"
                          :label="item.label"
                          :width="item.width"
                          :sortable="item.gridSort"
                          :fixed="item.gridFixed"
                          :formatter="(row, column, cellValue, index) => dataFormat(row, column, cellValue, index,item.type,item.format,item.mapValues,item.zeroShow)"
        >
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row[item.prop]" disabled></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column  show-overflow-tooltip v-else-if="item.typeExtends === 'efile'"
                          :align="item.align"
                          :key="item.key"
                          :prop="item.prop"
                          :label="item.label"
                          :width="item.width"
                          :sortable="item.gridSort"
                          :fixed="item.gridFixed"
                          :formatter="(row, column, cellValue, index) => dataFormat(row, column, cellValue, index,item.type,item.format,item.mapValues,item.zeroShow)"
        >
          <template slot-scope="scope">
            <single-upload-buttons :mObj="scope.row" :mProp="item.prop" :fileProps="item.efileParas" formDisabled position="table"></single-upload-buttons>
          </template>
        </el-table-column>
        <el-table-column  show-overflow-tooltip v-else-if="item.typeExtends === 'icon'"
                          :align="item.align"
                          :key="item.key"
                          :prop="item.prop"
                          :label="item.label"
                          :width="item.width"
                          :sortable="item.gridSort"
                          :fixed="item.gridFixed"
                          :formatter="(row, column, cellValue, index) => dataFormat(row, column, cellValue, index,item.type,item.format,item.mapValues,item.zeroShow)"
        >
          <template slot-scope="scope">
            <icon-element :mObj="scope.row" :mProp="item.prop" :mClearAble="false" :mReadOnly="true"></icon-element>
          </template>
        </el-table-column>
        <el-table-column  show-overflow-tooltip v-else
                          :align="item.align"
                          :key="item.key"
                          :prop="item.prop"
                          :label="item.label"
                          :width="item.width"
                          :sortable="item.gridSort"
                          :fixed="item.gridFixed"
                          :formatter="(row, column, cellValue, index) => dataFormat(row, column, cellValue, index,item.type,item.format,item.mapValues,item.zeroShow)"
        >
        </el-table-column>
      </template>
    </div>
</template>

<script>
import dateUtils from '@/assets/js/dateUtils.js'
import numberUtils from '@/assets/js/numberUtils.js'
import SingleUploadButtons from '@/components/base/SingleUploadButtons.vue'
import IconElement from '@/components/base/IconElement.vue'
import MhLink from '@/components/base/MhLink.vue'
import ElSelectOptions from '@/components/base/ElSelectOptions.vue'
export default {
  name: 'TableColumn',
  props: ['columns', 'dynamicFuncObj'],
  computed: {
    displayColumns () {
      const that = this
      let max = -1
      let od = -1
      for (const i in that.columns) {
        if ((that.columns[i].order > od) && (that.columns[i].display === true)) {
          max = i
          od = that.columns[i].order
        }
        if (that.columns[i].gridSlot.header && that.columns[i].typeExtends === 'select') {
          const headerModelOld = that.columns[i].gridSlot.headerModelOld
          that.columns[i].gridSlot.headerModel = this.getHeaderSeletDefVal(that.columns[i].default, that.columns[i].type)
          // console.log(headerModelOld, that.columns[i].gridSlot.headerModel)
          if (that.columns[i].gridSlot.headerModel !== headerModelOld) {
            this.headerSelectChanged(that.columns[i].gridSlot.headerModel, that.columns[i].default, that.columns[i].prop, that.columns[i].type)
            that.columns[i].gridSlot.headerModelOld = that.columns[i].gridSlot.headerModel
          }
          // that.columns[i].gridSlot.headerModel = this.$Any.getCurrentHrSite()
        }
      }
      if (max >= 0) {
        that.columns[max].order = 0
      }
      // console.log('TableColumn', that.columns)
      return this.$Any.newArraySortByKey(that.columns, 'order').filter(item => {
        return item.display === true
      })
    },
    hidden () {
      return false
    }
  },
  components: {
    SingleUploadButtons,
    MhLink,
    IconElement,
    ElSelectOptions
  },
  methods: {
    handleClick (index, row, functions) {
      const that = this
      if (functions !== '') {
        const funcs = that.dynamicFuncObj || that.$parent.dynamicFuncs
        if (funcs[functions]) {
          funcs[functions](index, row, that)
        }
      }
    },
    dataFormat (row, column, cellValue, index, vtype, format, mapValues, zeroShow) {
      if (vtype === 'date') {
        return dateUtils.formatDate(cellValue, format)
      } else if (vtype === 'boolean') {
        if (cellValue) return '√'
        else { return '' }
      } else if ((vtype === 'number') || (vtype === 'int')) {
        if ((cellValue === 0) && (zeroShow !== '')) {
          return zeroShow
        } else if (format === '') {
          return cellValue
        } else {
          if (cellValue < 0) {
            return ('-' + numberUtils.formatNumber(Math.abs(cellValue), format))
          } else {
            return numberUtils.formatNumber(cellValue, format)
          }
        }
      } else {
        return this.getMapValues(vtype, cellValue, mapValues)
      }
    },
    getMapValues (vtype, val, mapValues) {
      if (mapValues) {
        const options = mapValues.options
        for (const i in options) {
          if (options[i][mapValues.value] === val) {
            return options[i][mapValues.label]
          }
        }
        return val
      } else {
        return val
      }
    },
    getHeaderSeletDefVal (def, type) {
      return this.$Any.getDefaultValue(def, type)
    },
    headerSelectChange (val, def, field, type) {
      if (def === '$HRSITE' && val !== '') {
        window.sessionStorage.setItem('currentHrSite', val)
      }
    },
    headerSelectChanged (val, def, field, type) {
      let para = {}
      if (!val) {
        para = {}
      } else {
        para = {
          qJoin: 'and',
          qField: field,
          qOp: '=',
          qValue: val,
          qType: type
        }
      }
      this.$emit('hraderCondition', para)
    },
    arrayTableSortByKey: function (array, key) {
      const len = array.length
      const array2 = new Array(len)
      for (const i in array) {
        if ((i + 1) === len) {
          array2[0] = array[i]
        } else {
          array2[i + 1] = array[i]
        }
      }
      return this.$Any.arraySortByKey(array2, 'order')
    }
  },
  mounted () {
  }
}
</script>

<style lang="less">
  .header-select {
    //.el-input--suffix .el-input__inner {
    //  padding-right: 20px;
    //}
    .el-input__inner {
      //border: 1px solid white;
      //color: #303133;
      //font-size: 13px;
      color: #409eff;
      font-weight: bold;
    }
    //.el-select__caret {
    //  color: #303133;
    //  font-weight: bold;
    //  margin-left: 5px;
    //  line-height: 25px;
    //}
  }
</style>
